import { render, staticRenderFns } from "./dashboardIframePowerBI.vue?vue&type=template&id=0ae62e9b&"
import script from "./dashboardIframePowerBI.vue?vue&type=script&lang=js&"
export * from "./dashboardIframePowerBI.vue?vue&type=script&lang=js&"
import style0 from "./dashboardIframePowerBI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports